import { useState } from 'react';

interface UseTemplateNameValidationParams {
  currentTemplateName?: string;
  existingNames?: string[];
  t: (key: string) => string;
  validationKeyPrefix: string;
}

export function useTemplateNameValidation({
  currentTemplateName,
  existingNames,
  t,
  validationKeyPrefix
}: UseTemplateNameValidationParams) {
  const [templateNameError, setTemplateNameError] = useState('');

  const validateTemplateName = (name: string): boolean => {
    if (!name?.trim()) {
      setTemplateNameError(t(`${validationKeyPrefix}.validation.nameRequired`));
      return false;
    }

    const otherNames = existingNames?.filter(
      (n) => n.toLowerCase() !== currentTemplateName?.toLowerCase()
    );

    if (otherNames?.map((n) => n.toLowerCase()).includes(name.toLowerCase())) {
      setTemplateNameError(
        t(`${validationKeyPrefix}.validation.nameDuplicate`)
      );
      return false;
    }

    setTemplateNameError('');
    return true;
  };

  const clearTemplateNameError = () => {
    setTemplateNameError('');
  };

  return {
    templateNameError,
    validateTemplateName,
    clearTemplateNameError,
    setTemplateNameError
  };
}
